function initEvents(root=document){
 root.querySelectorAll('[data-phobos-events]:not([data-ready])').forEach(host=>{
  const list=host.querySelector('.ph-events'),select=host.querySelector('[data-event-game]'),filters=host.querySelector('[data-event-filters]'),empty=host.querySelector('[data-events-empty]');if(!list||!select||!filters||!empty)return;
  host.dataset.ready='true';const all=[...host.querySelectorAll('[data-event]')];
  const valid=all.filter(x=>Number.isFinite(Date.parse(x.dataset.start))&&Date.parse(x.dataset.start)>=Date.now());all.filter(x=>!valid.includes(x)).forEach(x=>x.hidden=true);
  valid.sort((a,b)=>Date.parse(a.dataset.start)-Date.parse(b.dataset.start)).forEach(x=>list.append(x));
  new Set(valid.map(x=>x.dataset.game).filter(Boolean)).forEach(game=>select.add(new Option(game,game)));
  filters.hidden=!valid.length;
  function filter(){valid.forEach(x=>x.hidden=Boolean(select.value&&x.dataset.game!==select.value));empty.hidden=valid.some(x=>!x.hidden);}
  select.addEventListener('change',filter);filter();
  const format=new Intl.DateTimeFormat('de-DE',{timeZone:'Europe/Berlin',dateStyle:'medium',timeStyle:'short'});
  valid.forEach(x=>{x.querySelector('time').textContent=format.format(new Date(x.dataset.start));const button=x.querySelector('[data-event-calendar]');button.hidden=false;button.addEventListener('click',()=>{
   const esc=s=>String(s||'').replace(/\\/g,'\\\\').replace(/\r?\n/g,'\\n').replace(/,/g,'\\,').replace(/;/g,'\\;');
   const stamp=s=>new Date(s).toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'');
   const lines=['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Phobos//Events//DE','BEGIN:VEVENT','UID:'+encodeURIComponent(x.dataset.title+x.dataset.start)+'@'+location.hostname,'DTSTAMP:'+stamp(Date.now()),'DTSTART:'+stamp(x.dataset.start),'SUMMARY:'+esc(x.dataset.title),'LOCATION:'+esc(x.dataset.location),'URL:'+esc(x.querySelector('a')?.href||location.href),'END:VEVENT','END:VCALENDAR'];
   const blob=new Blob([lines.join('\r\n')+'\r\n'],{type:'text/calendar;charset=utf-8'}), url=URL.createObjectURL(blob),link=document.createElement('a');link.href=url;link.download='phobos-event.ics';link.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
  });});
 });
}
initEvents();document.addEventListener('shopify:section:load',e=>initEvents(e.target));

/* Inhaltsverzeichnis der Rechtstexte -----------------------------------------
   Baut sich aus den h2 des Richtlinien-HTML. Erst ab drei Abschnitten, sonst
   ist es mehr Gerüst als Hilfe. Der gerade gelesene Abschnitt wird markiert. */
(function () {
  var root = document.querySelector('[data-legal]');
  if (!root) return;
  var text = root.querySelector('[data-legal-text]');
  var nav = root.querySelector('.legal__toc');
  var list = root.querySelector('[data-legal-toc]');
  if (!text || !nav || !list) return;

  var heads = Array.prototype.slice.call(text.querySelectorAll('h2'));
  if (heads.length < 3) return;

  var links = heads.map(function (h, i) {
    if (!h.id) h.id = 'abschnitt-' + (i + 1);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
    return a;
  });
  nav.hidden = false;

  if (!('IntersectionObserver' in window)) return;
  var active = null;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var i = heads.indexOf(e.target);
      if (i < 0 || links[i] === active) return;
      if (active) active.removeAttribute('aria-current');
      active = links[i];
      active.setAttribute('aria-current', 'true');
    });
  }, { rootMargin: '-100px 0px -70% 0px', threshold: 0 });
  heads.forEach(function (h) { io.observe(h); });
})();

/* Breite Tabellen in Rechtstexten dürfen scrollen statt die Seite zu sprengen. */
(function () {
  document.querySelectorAll('.rte table').forEach(function (t) {
    if (t.parentElement && t.parentElement.classList.contains('table-wrap')) return;
    var wrap = document.createElement('div');
    wrap.className = 'table-wrap';
    t.parentNode.insertBefore(wrap, t);
    wrap.appendChild(t);
  });
})();

/* Countdown bis zum Saisonstart. Erst sichtbar, wenn ein gültiger Termin in der
   Zukunft liegt — ein Countdown auf 00:00:00 wäre schlimmer als keiner. */
(function () {
  var el = document.querySelector('[data-countdown]');
  if (!el) return;
  var raw = el.getAttribute('data-countdown');
  var target = new Date(String(raw).trim().replace(' ', 'T'));
  if (isNaN(target.getTime())) return;
  var d = el.querySelector('[data-cd-d]'), h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var left = target.getTime() - Date.now();
    if (left <= 0) { el.hidden = true; return; }
    var mins = Math.floor(left / 60000);
    d.textContent = Math.floor(mins / 1440);
    h.textContent = pad(Math.floor(mins % 1440 / 60));
    m.textContent = pad(mins % 60);
    el.hidden = false;
  }
  tick();
  window.setInterval(tick, 30000);
})();

/* Rückblick auf der Wir-Seite ------------------------------------------------
   Die Liste sagte nur Datum, Titel und Spiel. Jetzt hängt an jeder Zeile
   Bild, Set und Rückblick: am Zeiger als Blase, auf dem Handy aufgeklappt.
   Ohne JavaScript steht alles offen da — zugeklappt wird erst hier. */
(function () {
  var liste = document.querySelector('.pastlist[data-pastpop]');
  if (!liste) return;
  liste.setAttribute('data-ready', '');

  var ABSTAND = 16;   /* Luft zwischen Zeiger und Blase */
  var RAND = 12;      /* Mindestabstand zum Fensterrand */
  var offen = null;

  /* Beim Zuklappen darf nichts weiterlaufen: das Feld verschwindet, der Ton
     bliebe sonst und man faende die Quelle nicht mehr. */
  function anhalten(blase) {
    blase.querySelectorAll('video').forEach(function (v) { v.pause(); });
  }

  function zuklappen() {
    if (!offen) return;
    anhalten(offen.blase);
    offen.blase.classList.remove('is-open');
    offen.knopf.setAttribute('aria-expanded', 'false');
    offen = null;
  }

  function anZeiger(blase, x, y) {
    var r = blase.getBoundingClientRect();
    var lx = x + ABSTAND;
    var ly = y + ABSTAND;
    /* Am rechten oder unteren Rand kippt die Blase auf die andere Seite,
       sonst stünde sie halb ausserhalb des Fensters. */
    if (lx + r.width > window.innerWidth - RAND) lx = x - r.width - ABSTAND;
    if (ly + r.height > window.innerHeight - RAND) ly = y - r.height - ABSTAND;
    if (lx < RAND) lx = RAND;
    if (ly < RAND) ly = RAND;
    blase.style.transform = 'translate3d(' + Math.round(lx) + 'px,' + Math.round(ly) + 'px,0)';
  }

  liste.querySelectorAll('.pastrow').forEach(function (zeile) {
    var knopf = zeile.querySelector('.pastrow__b');
    var blase = zeile.querySelector('.pastbub');
    if (!knopf || !blase) return;
    var schwebt = false;

    function absetzen() {
      if (!schwebt) return;
      schwebt = false;
      blase.classList.remove('is-float');
      blase.style.transform = '';
    }

    knopf.addEventListener('pointerenter', function (e) {
      /* Nur echte Mauszeiger. Auf dem Handy folgt gleich das Antippen. */
      if (e.pointerType !== 'mouse') return;
      if (offen && offen.blase === blase) return;
      schwebt = true;
      blase.classList.add('is-float');
      anZeiger(blase, e.clientX, e.clientY);
    });
    knopf.addEventListener('pointermove', function (e) {
      if (schwebt) anZeiger(blase, e.clientX, e.clientY);
    });
    knopf.addEventListener('pointerleave', absetzen);

    knopf.addEventListener('click', function () {
      var war = offen && offen.blase === blase;
      zuklappen();
      absetzen();
      if (war) return;
      blase.classList.add('is-open');
      knopf.setAttribute('aria-expanded', 'true');
      offen = { blase: blase, knopf: knopf };
    });
  });

  /* Bildauswahl: ein Klick im Streifen holt das Bild nach oben in die grosse
     Flaeche, das bisherige rueckt in den Streifen zurueck. Erst hier werden
     die Knoepfe bedienbar — im Markup stehen sie auf tabindex="-1", weil sie
     ohne dieses Skript nichts tun.

     In der schwebenden Blase greift das nicht: die nimmt keine Zeiger an.
     Gewechselt wird also im aufgeklappten Feld, auf dem Telefon nach dem
     Antippen. Die Blase zeigt danach dasselbe Bild — es ist derselbe Knoten. */
  liste.querySelectorAll('[data-galwahl]').forEach(function (streifen) {
    var blase = streifen.closest('.pastbub');
    var flaeche = blase && blase.querySelector('.pastbub__art');
    var gross = flaeche && flaeche.querySelector('img');
    if (!gross) return;
    var knoepfe = [].slice.call(streifen.querySelectorAll('[data-pick]'));

    var filme = [].slice.call(blase.querySelectorAll('.pastbub__kino'));

    /* spielen ist beim ersten Aufruf falsch: da wird nur hergerichtet, was
       ohnehin schon zu sehen ist. Losgehen soll es erst auf einen Klick —
       das ist auch die Handbewegung, die Browser fuers Abspielen verlangen. */
    function zeigen(k, spielen) {
      knoepfe.forEach(function (a) {
        var an = a === k;
        a.classList.toggle('is-on', an);
        a.setAttribute('aria-pressed', an ? 'true' : 'false');
      });
      /* srcset zuerst leeren: sonst bliebe der Browser beim alten Satz, weil
         er dort schon eine passende Breite gefunden hat, und src waere wirkungslos. */
      gross.removeAttribute('srcset');
      gross.src = k.getAttribute('data-gross');
      gross.srcset = k.getAttribute('data-satz') || '';
      flaeche.classList.toggle('gart--hoch', k.hasAttribute('data-hoch'));

      /* Bei einem Foto verschwinden alle Videoflaechen und das Standbild in
         der Bildflaeche bleibt stehen; bei einem Video kommt genau eine nach
         vorn. Das Standbild darunter ist dasselbe — deshalb sieht man auch
         in der schwebenden Blase, wo nur es sichtbar ist, das Richtige. */
      var nr = k.getAttribute('data-film');
      var dran = null;
      filme.forEach(function (f) {
        var an = nr !== null && f.getAttribute('data-film') === nr;
        if (an) dran = f;
        else f.querySelectorAll('video').forEach(function (v) { v.pause(); });
        f.hidden = !an;
      });
      if (!dran || !spielen) return;
      var v = dran.querySelector('video');
      if (!v) return;
      var lauf = v.play();
      /* Lehnt der Browser ab — Stromsparen, strenge Einstellung —, steht das
         Video eben mit seiner Bedienleiste da. Ein Fehler ist das nicht. */
      if (lauf && lauf.catch) lauf.catch(function () {});
    }

    knoepfe.forEach(function (k) {
      k.tabIndex = 0;
      k.setAttribute('aria-pressed', k.classList.contains('is-on') ? 'true' : 'false');
      k.addEventListener('click', function () {
        zeigen(k, true);
      });
    });

    var erster = streifen.querySelector('[data-pick].is-on') || knoepfe[0];
    if (erster) zeigen(erster, false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !offen) return;
    var knopf = offen.knopf;
    zuklappen();
    knopf.focus();
  });
})();

/* Filterfach im Shop auf schmalen Schirmen -----------------------------------
   Ohne JavaScript bleibt es beim Kaestchen-Trick: das Label oeffnet und
   schliesst per Klick. Mit JavaScript verhaelt sich das Fach wie ein Dialog,
   denn es liegt als Vollbild-Ebene ueber allem:
   · Beim Oeffnen springt der Fokus hinein.
   · Alles ausserhalb wird inert. Vorher lief Tab aus dem offenen Fach heraus
     zu Sortierung und Chips, die komplett verdeckt waren.
   · Escape schliesst; der Fokus kehrt zum Schalter zurueck.
   · „Schliessen" ist ein <label> und damit nicht fokussierbar — es bekommt
     tabindex und reagiert auf Enter und Leertaste.
   Auf breiten Schirmen ist das Fach eine feste Seitenleiste; dort bleibt
   alles, wie es ist. */
(function () {
  var schalter = document.getElementById('facet-toggle');
  var fach = document.getElementById('PhobosFilters');
  if (!schalter || !fach) return;
  var gesperrt = [];

  function istEbene() { return getComputedStyle(fach).position === 'fixed'; }

  function sperren(an) {
    gesperrt.forEach(function (el) { el.inert = false; });
    gesperrt = [];
    if (!an) return;
    /* Von der Ebene nach oben bis zum body: an jeder Stufe alle Geschwister
       stilllegen. Das Kaestchen selbst bleibt bedienbar — es ist der Schalter. */
    for (var n = fach; n && n.parentElement && n !== document.body; n = n.parentElement) {
      Array.prototype.forEach.call(n.parentElement.children, function (s) {
        if (s === n || s === schalter || s.inert || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(s.tagName)) return;
        s.inert = true; gesperrt.push(s);
      });
    }
  }

  function schliessen() {
    schalter.checked = false;
    sperren(false);
    schalter.focus();
  }

  schalter.addEventListener('change', function () {
    var offen = schalter.checked && istEbene();
    sperren(offen);
    if (offen) {
      var erstes = fach.querySelector('.facet-close, summary, a[href], button, input:not([type=hidden]), select');
      if (erstes) erstes.focus();
    } else if (fach.contains(document.activeElement)) {
      schalter.focus();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && schalter.checked && istEbene()) schliessen();
  });

  var zu = fach.querySelector('.facet-close');
  if (zu) {
    zu.tabIndex = 0;
    zu.setAttribute('role', 'button');
    zu.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); schliessen(); }
    });
  }
})();
